<template>
    <div>
        <v-card>
            <v-alert class="mt-12" color="primary" dark border="left">
            LIBRO VIRTUAL DE INTELIGENIO
            </v-alert>
        </v-card>
    <v-row>
      <v-col col="12" class="d-flex">
          
          <ButtonComp class="mx-2" textButton="Volver" iconBut="mdi-arrow-left" classColor="red" @click="goBack" normalButton/>    
  
      </v-col>
    </v-row>
  
        <v-card-title class="d-flex justify-center py-2" >{{iframeUrl[0].area}}</v-card-title>
                
        <iframe name="simuladoresphet" height="900" width="100%" frameborder="0" :src="baseURL+'/'+iframeUrl[0].path_contenido" allowfullscreen mozallowfullscreen webkitallowfullscreen></iframe>

  
    </div>
</template>
<script>
import {BUCKET_ORIGIN_SPACE} from '../../../helpers/axios'
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';


export default {
    
    components:{
      ButtonComp
    },
    
    data (){
    return {
   
    baseURL: BUCKET_ORIGIN_SPACE,
    estudianteData: this.getEstudianteData()
    };
       
    },


    mounted() {
          
    },

    computed: {
        iframeUrl() {
        const match = this.estudianteData.book.filter(item => item.area === this.estudianteData.level);
        return match ? match : '';
        }
    },    

    methods: {
    goBack() {
      this.$router.push({ name: 'libroVirtualGrado' });
    },
    getEstudianteData() {
      let data = { level: this.$route.params.level, book: this.$route.params.book };
      return data;
    },
   
  },
};
</script>



<style scoped>

</style>